document.addEventListener("DOMContentLoaded", function () {
    // Initialize preferences button functionality
    const preferencesBtn = document.getElementById("cookie-btn-preferences");
    if (preferencesBtn) {
        preferencesBtn.addEventListener('click', function() {
            // Show preferences panel
            const preferencesEl = document.getElementById('cookie-preferences');
            if (preferencesEl) {
                preferencesEl.style.display = 'block';
            }

            // Hide initial content
            const initialContent = document.getElementById('cookie-initial-content');
            if (initialContent) {
                initialContent.style.display = 'none';
            }

            // Show back button and hide main buttons
            document.getElementById('main-buttons').style.display = 'none';
            document.getElementById('pref-buttons').style.display = 'block';

            // Pre-check boxes based on existing consent
            if (getCookie('consent_analytics') === 'granted') {
                document.querySelector('input[name="analytics"]').checked = true;
            }
            if (getCookie('consent_marketing') === 'granted') {
                document.querySelector('input[name="marketing"]').checked = true;
            }
        });
    }

    // Initialize back button functionality
    const backBtn = document.getElementById("cookie-btn-back");
    if (backBtn) {
        backBtn.addEventListener('click', function() {
            // Hide preferences panel
            const preferencesEl = document.getElementById('cookie-preferences');
            if (preferencesEl) {
                preferencesEl.style.display = 'none';
            }

            // Show initial content
            const initialContent = document.getElementById('cookie-initial-content');
            if (initialContent) {
                initialContent.style.display = 'block';
            }

            // Hide back button and show main buttons
            document.getElementById('main-buttons').style.display = 'flex';
            document.getElementById('pref-buttons').style.display = 'none';
        });
    }

    // Handle the consent form submission
    const consentForm = document.getElementById("cookie-consent-form");
    if (consentForm) {
        consentForm.addEventListener('submit', function(e) {
            e.preventDefault();

            const analyticsConsent = document.querySelector('input[name="analytics"]').checked ? 'granted' : 'denied';
            const marketingConsent = document.querySelector('input[name="marketing"]').checked ? 'granted' : 'denied';

            setCookie('consent_analytics', analyticsConsent, 365);
            setCookie('consent_marketing', marketingConsent, 365);
            setCookie('consent_modal', 'dismissed', 365);

            updateConsentState(analyticsConsent, marketingConsent);

            document.getElementById('cookie-consent-bar').remove();
        });
    }

    // Initialize Cookie Consent Banner
    if (!getCookie('consent_modal')) {
        const el = document.getElementById('cookie-consent-bar');
        if (el) {
            el.style.display = 'block';
        }

        // Set default values if not set
        if (!getCookie('consent_analytics')) {
            setCookie('consent_analytics', 'denied', 365);
        }
        if (!getCookie('consent_marketing')) {
            setCookie('consent_marketing', 'denied', 365);
        }
    }

    /** Accept only necessary cookies */
    let onlyNecessaryBtn = document.getElementById("cookie-btn-necessary");
    if (onlyNecessaryBtn) {
        onlyNecessaryBtn.addEventListener('click', function () {
            setCookie('consent_analytics', 'denied', 365);
            setCookie('consent_marketing', 'denied', 365);
            setCookie('consent_modal', 'dismissed', 365);

            updateConsentState('denied', 'denied');

            document.getElementById('cookie-consent-bar').remove();
        });
    }

    /** Accept all cookies */
    let allBtn = document.getElementById("cookie-btn-all");
    if (allBtn) {
        allBtn.addEventListener('click', function () {
            setCookie('consent_analytics', 'granted', 365);
            setCookie('consent_marketing', 'granted', 365);
            setCookie('consent_modal', 'dismissed', 365);

            updateConsentState('granted', 'granted');

            document.getElementById('cookie-consent-bar').remove();
        });
    }

    /** Show consent **/
    let showConsentBtn = document.querySelector("a[href='#cookies-modal']");
    if (showConsentBtn) {
        showConsentBtn.addEventListener('click', function (e) {
            deleteCookie('consent_analytics');
            deleteCookie('consent_marketing');
            deleteCookie('consent_modal');
            location.reload();
        });
    }
});

/**
 * Update Google Consent Mode settings based on user choices
 */
function updateConsentState(analyticsConsent, marketingConsent) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {dataLayer.push(arguments);}

    gtag('consent', 'update', {
        'ad_personalization': marketingConsent,
        'ad_storage': marketingConsent,
        'ad_user_data': marketingConsent,
        'analytics_storage': analyticsConsent,
        'functionality_storage': 'granted',
        'personalization_storage': analyticsConsent,
        'security_storage': 'granted'
    });

    if (analyticsConsent === 'granted' || marketingConsent === 'granted') {
        if (typeof initFacebookPixel === 'function') {
            initFacebookPixel();
        }
    }
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/; SameSite=Lax';
}